module.exports = "./img/desktop_logo.cd46148.png";